export default function BackIcon() {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.334 16L20.6673 16M11.334 16L13.8438 13.3333L15.0987 12M11.334 16L13.8438 18.6667L15.0987 20'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
